import { ICommandMapper } from '../ICommandMapper';
import { AddTaskBeforeOrAfterCommand, OfflineEditableCommand } from '@/models/api';
import { EditStore, Edit } from '../EditStore';
import ConvertCommandsToBaselineHelper from './Helpers/ConvertCommandsToBaselineHelper';

export class AddTaskBeforeOrAfterCommandMapper implements ICommandMapper<AddTaskBeforeOrAfterCommand> {
    commandType = 'AddTaskBeforeOrAfterCommand';
    async onQueue(command: AddTaskBeforeOrAfterCommand, store: EditStore) {
        await ConvertCommandsToBaselineHelper.onQueue(command, store);
    }
    onDequeue(edit: Edit<OfflineEditableCommand>, attemptedAt: Date): Edit<any> {
        return ConvertCommandsToBaselineHelper.onDequeue(edit, attemptedAt);
    }
    mappers = [ConvertCommandsToBaselineHelper.createShiftModelMapper<AddTaskBeforeOrAfterCommand>()];
}

export default new AddTaskBeforeOrAfterCommandMapper();
